import { ProductName } from 'Constants/products.constants';
import { CancelDateCategory } from 'Forms/CancelFormV2/cancelForm.constants';
import { CancelElectricScooterRequest } from '../cancelElectricScooterForm.types';

export function mapToCancellationElectricScooter(): CancelElectricScooterRequest {
  return {
    insuranceName: ProductName.ELECTRIC_SCOOTER,
    cancelDateCategory: CancelDateCategory.TOMORROW,
  };
}
